module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Solicitações'
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Solicitações de Prestação de Contas (Modelo Simplificado)")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_vm._v("\n        Lista de todos os IDs em aberto e seus respectivos estados\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e88d0aec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/prestacaoContasSimplificado/ListaValidacaoPrestacaoCOntasSimplificado.vue
// module id = 2101
// module chunks = 1